<template>
    <v-list-item
        :active="false"
        class="post-item tw-bg-white"
        :data-id="post.id"
        :ripple="false"
        :to="{
            name: post.toPostPage,
            params: { id: post.id },
        }">
        <v-list-item-subtitle
            class="tw-mb-2 tw-text-xs tw-uppercase tw-opacity-100 sm:tw-text-sm"
            :class="post.categoryTextClass">
            <CategoryName :category="post.category" />
        </v-list-item-subtitle>
        <v-list-item-title
            class="tw-line-clamp-2 tw-text-wrap tw-font-title tw-text-sm tw-font-medium tw-leading-tight tw-text-dark sm:tw-text-base"
            v-html="post.title">
        </v-list-item-title>
        <v-list-item-subtitle class="tw-mt-auto tw-text-xxs sm:tw-text-xs">
            {{ post.relativeDate }}
        </v-list-item-subtitle>

        <template #prepend>
            <v-avatar
                class="tw-size-[84px] tw-text-sm sm:tw-size-24"
                rounded="lg">
                <v-img :src="post.thumbnailSrc"></v-img>
            </v-avatar>
        </template>
    </v-list-item>
</template>

<script setup lang="ts">
    import { usePost } from '@/composables/usePost';
    import type { Category } from '@/configs/categories';
    import type { WPPost } from '@/contentTypes';

    const props = defineProps<{
        post: Partial<WPPost>;
        category?: Category;
    }>();

    const post = computed(() => usePost(props.post, props.category));
</script>

<style lang="scss">
    .post-item {
        .v-list-item__content {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        .v-list-item__prepend {
            margin-bottom: auto;
        }
    }
</style>
